import BadgeIcon from "../../../Icons/BadgeIcon";
import React, { useEffect, useState } from "react";
function ChooseImage({
  entryjson,
  inputs,
  setInputs,
  saveMemberEntry,
  contestPageDetails,
}) {
  // const { showToast } = useToast();
  let entrydet;
  let imglist;
  const [selectedImages, setSelectedImages] = useState([]);
  if (entryjson.entry) {
    entrydet = JSON.parse(entryjson.entry);
    imglist = entrydet.image;
    // console.log(entrydet.image);
  }

  useEffect(() => {
    setInputs((inputs) => {
      return {
        entry_val: selectedImages || "", // Use selectedImages or an empty string
      };
    });
  }, [selectedImages, setInputs]);

  // const chooseImage = (image) => {
  //     setSelectedImages((prevSelectedImages) => {
  //         if (prevSelectedImages.includes(image)) {
  //             return prevSelectedImages.filter((img) => img !== image);
  //         } else {
  //             return [...prevSelectedImages, image];
  //         }
  //     });
  // };

  const saveEntry = () => {
    //console.log(inputs);
    saveMemberEntry();
  };

  const toggleImageSelection = (imgdet) => {
    setSelectedImages((prevSelected) => {
      const isSelected = prevSelected.includes(imgdet);
      return isSelected
        ? prevSelected.filter((img) => img !== imgdet)
        : [...prevSelected, imgdet];
    });
  };

  return (
    <div className="cursor-default">
      <div className="flex flex-col md:flex-row justify-between">
        <div className="md:w-[440px]">
          <h4 className="font-medium text-[15px] leading-[22px] text-black opacity-100 mb-1">
            Choose an Image
          </h4>
        </div>
        <div className="hidden min-[426px]:block">
          <span class="earn_points_btn bg-white text-[#0274F7] text-sm font-medium inline-flex items-center px-3 py-1 rounded-md border border-[#0274F7]">
            <BadgeIcon width={20} height={20} className={"mr-1"} />
            {entrydet?.worth}
            <span className="text-sm ml-1">Points</span>
          </span>
        </div>
      </div>
      {/* <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3 mx-auto mt-4">
                {imglist.length > 0 ? (
                    imglist.map((imgdet, index) => (
                        <div key={index} className="flex items-center rounded-md">
                            <span style={{ cursor: 'pointer' }}  ><img className="w-[103px] h-[50px] md:w-[98px] md:h-[50px] rounded-md object-cover" style={{
                                border: selectedImages.includes(imgdet)
                                    ? `3px solid ${contestPageDetails?.primary_color}` // Add green border for selected images
                                    : 'none',
                            }} onClick={() => chooseImage(imgdet)} id={`img-${index}`} src={imgdet} alt="no-image" /></span>
                        </div>
                    ))
                ) : (
                    <div>No data Found </div>

                )}

            </div> */}

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3 mx-auto mt-4">
        {imglist.length > 0 ? (
          imglist.map((imgdet, index) => (
            <div
              key={index}
              className="relative flex items-center justify-center p-1"
            >
              <img
                className="w-full max-w-[103px] h-[50px] md:max-w-[98px] md:h-[50px] rounded-md object-cover cursor-pointer"
                style={{
                  border: selectedImages.includes(imgdet)
                    ? `3px solid ${contestPageDetails?.primary_color}`
                    : "none",
                }}
                onClick={() => toggleImageSelection(imgdet)}
                id={`img-${index}`}
                src={imgdet}
                alt="no-image"
              />
              {selectedImages.includes(imgdet) && (
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                  <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                    <svg
                      className="w-4 h-4 text-white"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M5 13l4 4L19 7"
                      ></path>
                    </svg>
                  </div>
                </div>
              )}
            </div>
          ))
        ) : (
          <div className="col-span-full text-center text-gray-500">
            No data found
          </div>
        )}
      </div>
      <div className="flex items-center justify-between">
        <div className="pt-2">
          <button
            disabled={!inputs?.entry_val}
            onClick={() => saveEntry()}
            className={`primary_btn_bg bg-[#0274F7] text-white px-3 py-2 rounded-md text-[13px] leading-[15px] border border-[#0274F7] ${
              !inputs?.entry_val
                ? "opacity-50 cursor-not-allowed"
                : " hover:bg-white hover:text-[#0274F7] hover:border-[#0274F7]"
            }`}
          >
            Earn Points
          </button>
        </div>
        <div className="pt-2">
          <span class="earn_points_btn bg-white ml-2 text-[#0274F7] text-sm font-medium inline-flex items-center px-3 py-1 rounded-md border border-[#0274F7] sm:hidden">
            <BadgeIcon width={20} height={20} className={"mr-1"} />
            {entrydet?.worth}
            <span className="text-sm ml-1">Points</span>
          </span>
        </div>
      </div>
    </div>
  );
}

export default ChooseImage;
